import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import KanbanColumn from './KanbanColumn';

const useStyles = makeStyles(theme => ({
  board: {
    display: 'flex',
    width: 'max-content',
    padding: theme.spacing(2),
    minHeight: 'calc(100vh - 320px)',
    gap: theme.spacing(2),
    backgroundColor: '#ffffff',
  },
}));

const KanbanBoard = ({ lanes, onCardMove, onLaneReorder, updateTicket, isAdmin }) => {
  const classes = useStyles();
  const boardRef = useRef(null);

  const handleDragEnd = result => {
    if (!result || !result.destination) return;

    const { source, destination, draggableId, type } = result;

    if (type === 'LANE') {
      if (source.index !== destination.index) {
        onLaneReorder(source.index, destination.index);
      }
      return;
    }

    if (
      source.droppableId !== destination.droppableId ||
      source.index !== destination.index
    ) {
      onCardMove(
        draggableId,
        destination.droppableId,
        source.droppableId,
        source.index,
        destination.index
      );
    }
  };

  // Limpar event listeners ao desmontar o componente
  useEffect(() => {
    return () => {
      // Remover todos os event listeners de drag do documento
      const events = ['dragstart', 'dragend', 'drag', 'dragover', 'dragenter', 'dragleave', 'drop'];
      events.forEach(event => {
        const listeners = document.querySelectorAll('[data-rbd-drag-handle-draggable-id]');
        listeners.forEach(element => {
          element.removeAttribute('data-rbd-drag-handle-draggable-id');
          element.removeAttribute('data-rbd-drag-handle-context-id');
        });
      });
      
      // Limpar estilos inline que podem ter sido adicionados
      const draggables = document.querySelectorAll('[data-rbd-draggable-id]');
      draggables.forEach(element => {
        element.removeAttribute('data-rbd-draggable-id');
        element.removeAttribute('data-rbd-draggable-context-id');
      });
    };
  }, []);

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="lanes" direction="horizontal" type="LANE">
        {(provided, snapshot) => (
          <div 
            className={classes.board}
            ref={(el) => {
              boardRef.current = el;
              provided.innerRef(el);
            }}
            {...provided.droppableProps}
          >
            {lanes.map((lane, index) => (
              <KanbanColumn
                key={lane.id}
                id={lane.id}
                title={lane.title}
                tickets={lane.tickets}
                color={lane.color}
                index={index}
                updateTicket={updateTicket}
                isAdmin={isAdmin}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default KanbanBoard;
